
var $ = jQuery.noConflict();
/* ------------------ Scripts for ALL Pages-------------------- */




document.addEventListener("DOMContentLoaded", (event) => { // Make sure everything in the DOM is loaded first
	
	
	
	jQuery('body').addClass('dom-loaded'); // Add a class to the body when fully loaded
	

		
		

	
	
	//SelfCare Optin Popup
	
	jQuery('#button-selfcare').click(function(){
		jQuery("#selfcare-optin-popup").addClass('on');
	});
	
	// SelfCare Optin Popup Close
	jQuery('#selfcare-optin-close').click(function(){
		//The User has not visited in this session		
		jQuery("#selfcare-optin-popup").delay(100).queue(function(next){
			jQuery("#selfcare-optin-popup").removeClass('on');
			next();
		});		
	});
	  
    
    // ---------------------------------- Accessibility Compliance ------------------- //
    
    // Add button role to links that don't have link
    
    jQuery(function(){
	  var hashlinks = jQuery('a[href="#"]');

	  hashlinks.each(function(){
		jQuery(this).attr('role','button');
	  });

	})
    
    // Assign role of "none"
    
    jQuery(function(){
	  var hashlinks = jQuery('.xoo-aff-input-icon');

	  hashlinks.each(function(){
		jQuery(this).attr('role','none');
	  });

	})
    
    // WooCommerce Show password button
    jQuery(function(){
	  var hashlinks = jQuery('.show-password-input');

	  hashlinks.each(function(){
		jQuery(this).attr('role','button').attr('aria-label','Show Password').attr('tabindex','0');
	  });

	})  
    
     jQuery(function(){
	  var hashlinks = jQuery('.woocommerce-LoopProduct-link');

	  hashlinks.each(function(){
		jQuery(this).attr('aria-label','Buy Now');
	  });

	}) 
    
    // WooCommerce required label
    jQuery(function(){
	  var hashlinks = jQuery('.woocommerce-form-login #username, .woocommerce-form-login #password');

	  hashlinks.each(function(){
		jQuery(this).attr('aria-required','true');
	  });

	})  
    
    // H2 tags
     jQuery(function(){
	  var p_tags = jQuery('.sessions-info-top p, .about-img-caption');

	  p_tags.each(function(){
		jQuery(this).attr('role','heading').attr('aria-level', '2');
	  });

	})
    
    //H3 tags
	jQuery(function(){
	  var p_tags = jQuery('.mm-quote p, .testimonial-text');

	  p_tags.each(function(){
		jQuery(this).attr('role','heading').attr('aria-level', '3');
	  });

	})
    
     //h4 tags
	jQuery(function(){
	  var p_tags = jQuery('.home-about-text p, .home-post-info p, .footer-location p');

	  p_tags.each(function(){
		jQuery(this).attr('role','heading').attr('aria-level', '4');
	  });

	})
    
   
    //iframes
    jQuery(function(){
	  var iframes = jQuery('iframe');

	  iframes.each(function(){
		jQuery(this).attr('aria-label','Embedded content');
	  });

	})
    
    // Add aria labels to links that open to new windows
    
    jQuery(function(){
	  var newWindowlinks = jQuery('a[target=_blank]');

	  newWindowlinks.each(function(){
		jQuery(this).attr('aria-label','Link opens in a new window');
	  });

	})
		
	
	
}); // End Window Load




document.addEventListener("DOMContentLoaded", (event) => {

	
	// First, move mega menus to be a child of the header

	

	// -------------- Set Up Waypoints ------------------//
	
	

	
	// -------------- Slick Sliders ------------------//
	
	jQuery('.press-logos-list').slick({
	  infinite: true,
	  slidesToShow: 4,
	  slidesToScroll: 4,
	  autoplay: true,
	  autoplaySpeed: 8000,
		arrows:true,
		dots:false,
		pauseOnFocus: false,
		pauseOnHover: false,
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 4
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 4
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				slidesToShow: 2,				  
	  			slidesToScroll: 2
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		  ]
	});

	// Append sliding doodad to slider dots

	jQuery('#home-products-slider').on('init', function(event, slick){
		
		//console.log('slider initialized')
		var doodad_width = jQuery('#home-products-slider ul.slick-dots li').width();
		console.log('list item is ' + doodad_width + ' wide');
		jQuery('#home-products-slider ul.slick-dots').append('<span></span>');
		jQuery('#home-products-slider ul.slick-dots span').width(doodad_width);
	});
	
	jQuery('#home-products-slider').on('afterChange', function(event, slick, currentSlide){
		var position = jQuery('#home-products-slider ul.slick-dots li.slick-active').position();
		console.log ('active slick is ' +  position.left + ' from the left');
		jQuery('#home-products-slider ul.slick-dots span').css('left', position.left);
	});

	jQuery('#home-products-slider').slick({
	  infinite: true,
	  slidesToShow: 4,
	  slidesToScroll: 4,
	  autoplay: true,
	  autoplaySpeed: 8000,
	  //variableWidth: true,
		arrows:true,
		dots:true,
		pauseOnFocus: false,
		pauseOnHover: false,
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 4
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 4
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				slidesToShow: 2,				  
	  			slidesToScroll: 2
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		  ]
	});

	
	jQuery('.home-testimonials-slider').slick({
		dots: false,
		arrows:true,
		adaptiveHeight: true,
		autoplay: true,		
	    infinite: true,
  		slidesToShow: 1,
		pauseOnFocus: false,
		pauseOnHover: false,		
		autoplaySpeed: 5000,
		responsive: [
			{
			  breakpoint: 480,
			  settings: {
				autoplay: false
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		  ]
		/*arrows: false,
		speed: 300,
		fade: true,
  		cssEase: 'linear'*/
	});

	jQuery('.announcement-slider').slick({
		dots: false,
		arrows:false,
		adaptiveHeight: true,
		autoplay: true,		
	    infinite: true,
  		slidesToShow: 1,
		pauseOnFocus: false,
		pauseOnHover: false,		
		autoplaySpeed: 5000,
		vertical: true,
		responsive: [
			{
			  breakpoint: 480,
			  settings: {
				arrows:false
				//autoplay: false
			  }
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		  ]
		/*arrows: false,
		speed: 300,
		fade: true,
  		cssEase: 'linear'*/
	});

	

	jQuery('.spa-times').on('init', function(event, slick) {
		// When the slider initializes, then run some code
		jQuery('.service-popup-open').click(function(e){
			e.preventDefault();
			var popup = jQuery(this).attr('data-popup');
			jQuery('.service-lightbox-overlay').addClass('open');
			console.log(popup);
			jQuery(popup).addClass('active');
			function show_popup(){
			jQuery(popup).addClass('open');
		};
		window.setTimeout( show_popup, 250 ); // .25 seconds

		});

		//Function to close the lightbox
		function close_team_lb() {

			jQuery(".service-lightbox").removeClass('open');

			function hide_bg(){
			jQuery(".service-lightbox-overlay").removeClass('open');
		};
		window.setTimeout( hide_bg, 250 ); // .25 seconds

			function hide_popup(){
			jQuery(".service-lightbox").removeClass('active');
		};
		window.setTimeout( hide_popup, 500 ); // .5 seconds

		}
		// If an event gets to the body
		jQuery(".service-lightbox-overlay").click(function(){

			close_team_lb();
		});

		// Prevent events from getting pass .popup
		jQuery(".service-lightbox").click(function(e){
		e.stopPropagation();
		});

		jQuery(".service-lb-nav-button").click(function(){
		close_team_lb();

		});
	});
	
	
	
	// Ellipsis
	jQuery(".ellipsis").dotdotdot({
		watch: "window"
	});

	
	// Determine whether we are on mobile or desktop
	
	  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) )
		{
		   //alert('You are using a mobile device!');
		   jQuery('body').addClass('touch');
		   jQuery('.berocket_aapf_widget-title').trigger('click');
		   
		}
		else
		{
		   //alert('You are not using a mobile device!');
		   
		   jQuery('body').addClass('no-touch');
		   
		   // Initiate skrollr.js 
			skrollr.init({forceHeight: false, smoothScrolling: false});
			
			//Sticky Plugin		
			//jQuery('#content').stickem();
			jQuery(".post-sidebar").stick_in_parent({
				offset_top: 100,
				bottoming: true
			});
		   
				
			jQuery(".post-content-share").stick_in_parent({
				offset_top: 200,
				bottoming: true
			});
            
            
		   
		}
	// End Determine if we are on mobile or desktop	
	

			
	
		
	
	//Blog Post Sharing
	jQuery(".post-sharing-title").click(function (e) { // Set up toggle class for Top Navigation			
			jQuery(this).addClass('off');
			jQuery('.post-sharing-sidebar').addClass('on');
		});
	
	
	//Intiate FancyBox for all links with the class .fancy
	jQuery('a.fancy').fancybox({
		preload: 1
	});
	
	
	
	

	/* Toggle Open Items */
	
	jQuery('.toggle-header').click(function () { // Enable the toggle view list for ul.toggle-view for toggle-able lists
 		var container = jQuery(this).closest('.toggle-view');
		var text = jQuery(this).closest('.toggle-view').children('div.panel');
		var span = jQuery(this).find('span.plus');
		
		//If the text (i.e. the panel div) is hidden, then open it up. Otherwise hide the open text.
		if (text.is(':hidden')) {
			text.slideDown('fast');
			span.html('-').addClass('open');  
			container.addClass('open');
		} else {
			text.slideUp('fast');
			span.html('+').removeClass('open'); 
			container.removeClass('open');
		}

	});
	jQuery('#tab-title-description').click(); // Click to open description first
	
	
	
		
	
	// Custom Function for the Brand Popup Info Item and its close button
	jQuery(".brand-open").click(function() { 
		var openme = jQuery(this).closest('.brand-grid-item').children('.brand-info-popup');
		jQuery(openme).removeClass('closed').addClass('open');
	});
	
	jQuery(".brand-info-close").click(function() { 
		var container = jQuery(this).closest('.brand-info-popup');
		jQuery(container).removeClass('open').addClass('closed');
	});
	
	
	
    // Add Conversion for Mangomint Spa Booking Links - gtag_report_conversion function added in Site Options > Tracking Pixel
    
    jQuery('a[href*="mangomint"]').click(function() {
        var url = jQuery(this).attr('href');
        return gtag_report_conversion(url);
    });
	
    // Custom Function for the Color Match Popup and its close button
	jQuery(".show-color-match-popup").click(function() { 
		
        jQuery('#color-match-popup-overlay').removeClass('closed').addClass('open');
		jQuery('#color-match-popup').removeClass('closed').addClass('open');
	});
	
	jQuery("#cm-popup-close").click(function() { 
        jQuery('#color-match-popup-overlay').removeClass('open').addClass('closed');
		jQuery('#color-match-popup').removeClass('open').addClass('closed');
	});
	



// GSAP Animation

var animation_setup = function(){
    // --------------------------------- GSAP/ScrollTrigger - scrolling and tweens ----------------------------- //
    
    gsap.registerPlugin(ScrollTrigger); // register the ScrollTrigger plugin first 
    gsap.config({
      autoSleep: 60,
      force3D: "auto",
      nullTargetWarn: false,
        invalidateOnRefresh: true
    });

	/* -------- General Animations -------- */
	// Run this format if there are multiple instances of an element on a page
    const fadeIn = gsap.utils.toArray('.fade-in');
    fadeIn.forEach(box => {
	  gsap.set(box, { opacity:0 });
      gsap.to(box, { 
        ease: "Strong.easeInOut",
		duration: .5,
        scrollTrigger: {
          trigger: box,
          start: "top 90%",
          end: "bottom top",        
          //toggleClass: "onscreen",
          toggleActions: "play none none none"
        },
		opacity: 1
      })
    });
    
    
    
    // Run this format if there are multiple instances of an element on a page
    const boxesFadeInLeft = gsap.utils.toArray('.fade-in-left');
    boxesFadeInLeft.forEach(box => {
      gsap.to(box, { 
        ease: "Strong.easeInOut",
        scrollTrigger: {
          trigger: box,
           start: "top 90%",
          end: "bottom top",        
          toggleClass: "onscreen",
            toggleActions: "play none none none"
        }
      })
    });
    
    // Run this format if there are multiple instances of an element on a page
    const boxesFadeInRight = gsap.utils.toArray('.fade-in-right');
    boxesFadeInRight.forEach(box => {
      gsap.to(box, { 
        ease: "Strong.easeInOut",
        scrollTrigger: {
          trigger: box,
           start: "top 90%",
          end: "bottom top",        
          toggleClass: "onscreen",
            toggleActions: "play none none none"
        }
      })
    });
    
     const boxesFadeInUp = gsap.utils.toArray('.fade-in-up');
    boxesFadeInUp.forEach(box => {
      gsap.to(box, { 
        ease: "Strong.easeInOut",
        scrollTrigger: {
          trigger: box,
           start: "top 90%",
          end: "bottom top",        
          toggleClass: "onscreen",
            toggleActions: "play none none none"
        }
      })
    });

	// Float up and down
	const boxesFloatSm = gsap.utils.toArray('.float-sm');
            boxesFloatSm.forEach(box => {
            gsap.set(box, {yPercent: 20});
            gsap.to(box, {   
            scrollTrigger: {
                    trigger: box, // start the animation when ".box" enters the viewport (once),
                    start: "top bottom",
                    end: "bottom top",
                    toggleClass: "onscreen",
                    scrub: 1,
                    toggleActions: "play none none none"
                }, 
                yPercent: -20,
                ease: "none"
            })
        });

        const boxesFloatMd = gsap.utils.toArray('.float-md');
            boxesFloatMd.forEach(box => {
            gsap.set(box, {yPercent: 40});
            gsap.to(box, {   
            scrollTrigger: {
                    trigger: box, // start the animation when ".box" enters the viewport (once),
                    start: "top bottom",
                    end: "bottom top",
                    toggleClass: "onscreen",
                    scrub: 1,
                toggleActions: "play none none none"
                }, 
                yPercent: -40,
                ease: "none"
            })
        });
            
        const boxesFloatLg = gsap.utils.toArray('.float-lg');
            boxesFloatLg.forEach(box => {
            gsap.set(box, {yPercent: 60});
            gsap.to(box, {   
            scrollTrigger: {
                    trigger: box, // start the animation when ".box" enters the viewport (once),
                    start: "top bottom",
                    end: "bottom top",
                    toggleClass: "onscreen",
                    scrub: 1,
                toggleActions: "play none none none"
                }, 
                yPercent: -60,
                ease: "none"
            })
        });

	/* ------- Batch Items ------- */

	// Speaker List Items

	gsap.set(".speaker-li", {opacity: 0, y: 25});
    
		ScrollTrigger.batch(".speaker-li", {
		duration:1,
        start: "top 90%",
        end: "bottom top", 
		onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15}, overwrite: true}),
		onLeave: batch => gsap.set(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		onLeaveBack: batch => gsap.set(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true})
			
	});

	//list 3 col

	gsap.set(".list-3-col li", {opacity: 0, y: 25});
    
		ScrollTrigger.batch(".list-3-col li", {
		duration:1,
        start: "top 90%",
        end: "bottom top", 
		onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15}, overwrite: true}),
		onLeave: batch => gsap.set(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		onLeaveBack: batch => gsap.set(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true})
			
	});
	
	// Reg-Thank-You/Affiliate Page Boxes and Menu //

    jQuery(".reg-ty-box").each(function() {
      var myID = jQuery(this).closest('.reg-ty-box-wrap').attr('id');
      
      // Content Reveal Animation
      ScrollTrigger.create({
        trigger: jQuery(this),
        start: "top 50%",
        end: "bottom 40%",
        onEnter: () => {
            jQuery(this).addClass('onscreen');
            //console.log(myID + ' has entered.');
            jQuery('#order-nav li[data-link*="' + myID + '"]').addClass('active');
        },
        onLeave: () => {
            jQuery(this).removeClass('onscreen');
            //console.log(myID + ' has exited.');
            jQuery('#order-nav li[data-link*="' + myID + '"]').removeClass('active');
        },
        onEnterBack: () => {
            jQuery(this).addClass('onscreen');
            //console.log(myID + ' has entered.');
            jQuery('#order-nav li[data-link*="' + myID + '"]').addClass('active');
        },
        onLeaveBack: () => {
            jQuery(this).removeClass('onscreen');
            //console.log(myID + ' has exited.');
            jQuery('#order-nav li[data-link*="' + myID + '"]').removeClass('active');
        }
      });
    });

	


	/* --------------- Animations based on Media Queries -------------- */

    ScrollTrigger.matchMedia({
        
      "(min-width: 768px)": function() {

        ScrollTrigger.create({
  
          trigger: 'section.order-flex',
          start: 'top top',
          end: 'bottom top',
          pin: '.order-flex-sidebar'
          
        })

      },

	  "(max-width: 768px)": function() {
		gsap.to(".open-page-nav", {
		scrollTrigger: {
			trigger: "#main", // start the animation when ".box" enters the viewport (once),
			start: "top top",
			end: "bottom bottom",
			scrub: true,
			toggleClass: {targets: ".open-page-nav", className: "onscreen"}
		},        
		ease: "none"
		});
	  }
    }); // End matchMedia
    

  }; // End animation setup
    
    
  window.addEventListener("load", (event) => {
    animation_setup();
  });
});
